import CrudController from "./crud_controller";

export default class extends CrudController {

  connect() {
    this.siteNum = this.data.get("siteNum");
    this.loadList();
  }

  loadList() {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/agencies`), this.listTarget)
      .then(() => {
        if(window.App.EDIT_MODE) this.showNewLink();
      });
  }

  handleAgencySearch(event)
  {
  }

  new(event) {
    this.clearMessage();
    this.fetchForTarget(window.App.prefixedUrl(`/sites/${this.siteNum}/agencies/new`), this.listTarget)
      .then(html => {
        this.hideNewLink();
        this.hideLoading();
      });
  }

  add(event) {
    this.clearMessage();
    let agencyNum = event.currentTarget.dataset.agencyNum;
    let controller = this;
    App.$rails.ajax({
      type: "POST",
      url: window.App.prefixedUrl(`/sites/${controller.siteNum}/agencies`),
      data: new URLSearchParams({ agency_search: `${agencyNum}` }).toString(),
      success(data) {
        controller.loadList();
      },
      error(data) {
        // TODO: Maybe render an error message?
      }
    });
  }
}